import store from '@/shared/store'

export default function useRequestView() {
  const VERIFICATION_TYPE = 'verificationRequest'
  const CONFIRMATION_TYPE = 'confirmationRequest'

  const fetchShiftsByRequestId = async id => {
    const shiftsVerification = await store.dispatch('appRequest/fetchShiftsByRequestId', {
      type: VERIFICATION_TYPE,
      // id: 'mqmZTVHlY0fV6JcmAq5A',
      id,
    })
    const shiftsConfirmation = await store.dispatch('appRequest/fetchShiftsByRequestId', {
      type: CONFIRMATION_TYPE,
      // id: 'AHMb6xVhqkjUI3oNVPKC',
      id,
    })

    return [...shiftsVerification, ...shiftsConfirmation]
  }

  const fetchRequest = async id => {
    const res = await store.dispatch('appRequest/fetchRequest', { id })
    return res
  }

  async function sendConfirmNotificationSMS({
    mobile, message,
  }) {
    await store.dispatch('appRequest/sendSMS', {
      mobile,
      message,
    })
  }

  /* async function sendConfirmationEmail({
    to, message, subject,
  }) {
    await store.dispatch('appRequest/sendVerificationEmail', {
      to,
      message,
      subject,
    })
  } */

  /* const getCancelShiftEmail = shift => {
    const { user, area } = shift
    const message = `<p style="text-transform:capitalize">Hei ${user.firstName},</p>
    <p>Your shift from ${shift.start.toLocaleString('fi')} to ${shift.end.toLocaleString('fi')} at <span style="text-transform:capitalize">${area.name}</span> has been canceled as the customer stated you did not complete your shift</p>
    <p>Please contact us if you disagree with the customer's statement</p>
    <p>Best regards,</p>
    <p>Hoiwa-timi</p>`
    return message
  } */

  async function updateConfirmationTicket({
    requester = null, ticketId, message, collaborators,
  }) {
    const response = await store.dispatch('appRequest/updateZendeskTicket', {
      requester,
      ticketId,
      message,
      collaborators,
    })
    return response.data
  }

  async function createConfirmationTicket({
    requester = null, groupId, message, subject, collaborators,
  }) {
    const response = await store.dispatch('appRequest/createZendeskTicket', {
      requester,
      groupId,
      message,
      subject,
      collaborators,
    })
    return response.data
  }

  async function updateClientRequest(id, updates) {
    await store.dispatch('appRequest/updateClientRequest', { id, updates })
  }

  async function updateShift({ id, updates }) {
    await store.dispatch('appRequest/updateShift', { id, updates })
  }

  return {
    fetchShiftsByRequestId,
    updateConfirmationTicket,
    createConfirmationTicket,
    updateClientRequest,
    updateShift,
    fetchRequest,
    sendConfirmNotificationSMS,
  }
}
